import {
  assignInnerRowGeometry,
  type getVisibleNodeNames,
  type ViewQueryRecordNode,
  type ViewQueryRecordNodeWithId,
} from '@salescore/core'
import { Array, Result } from 'effect'

import { toMutable } from '../../rsheet/types/DeepReadonly'

/**
 * 虫眼鏡での参照先の選択で書き換わった参照元・参照先のノードを、recordsImpl の更新値にする
 */
export const buildMagnifyingGlassRecordsImplUpdates = (
  nodes: ViewQueryRecordNode[],
  visibleNodeNames: ReturnType<typeof getVisibleNodeNames>,
): Array<{ id: string; value: ViewQueryRecordNodeWithId }> =>
  Array.filterMap(nodes, (node) =>
    // 参照元・参照先として収集するノードは保存済みレコードなので、id を持たないものは更新対象にならない
    node.id === undefined
      ? Result.failVoid
      : Result.succeed({
          id: node.id,
          value: toMutable(assignInnerRowGeometry(node, visibleNodeNames)),
        }),
  )
